import { Switch } from "react-router-dom";

import DespesaPages from "./Despesa";
import MovimentacoesBancariasPages from "./Geral/MovimentacoesBancarias";
import PrevisaoOrcamentariaPages from "./Planejamento/PrevisaoOrcamentaria";
import ReceitaPages from "./Receita";
import TransferenciasPages from "./Geral/Transferencias";
import RetornoBancarioPages from "./Geral/RetornoBancarioPages";
import AuthRoute from "components/AuthRoute";
import { PermissaoEnum } from "core/resources/enums/permissao";
import DashboardPages from "./Geral/Dashboard";
import ConciliacaoBancariaPages from "./Geral/ConciliacaoBancaria";
import ExecucaoOrcamentariaPages from "./Planejamento/ExecucaoOrcamentaria";
import { TipoTenantEnum } from "core/resources/enums/tenant";
import ImpostosPages from "./Impostos";
import ConsumoPages from "./Consumo";
import ExportacaoContabilPages from './ExportacaoContabil/index';
import CalendarioDepositosPages from './Geral/CalendarioDepositos';

function FinanceiroPages() {
  return (
    <Switch>
      <AuthRoute
        path="/financeiro/retorno-bancario"
        component={RetornoBancarioPages}
        permissions={[
          PermissaoEnum.Backoffice.Financeiro.RetornoBancario.Visualizar,
        ]}
      />
      <AuthRoute
        path="/financeiro/receita"
        component={ReceitaPages}
        permissions={[
          PermissaoEnum.Backoffice.Financeiro.ContasReceber.Visualizar,
        ]}
      />
      <AuthRoute
        path="/financeiro/despesa"
        component={DespesaPages}
        permissions={[
          PermissaoEnum.Backoffice.Financeiro.ContasPagar.Visualizar,
        ]}
      />
      <AuthRoute
        path="/financeiro/movimentacoes-bancarias"
        component={MovimentacoesBancariasPages}
        permissions={[PermissaoEnum.Backoffice.Financeiro.MovimentacaoBancaria]}
      />
      <AuthRoute
        path="/financeiro/calendario-depositos"
        component={CalendarioDepositosPages}
        permissions={[
          PermissaoEnum.Backoffice.Financeiro.MovimentacaoBancaria,
        ]}
      />
      <AuthRoute
        path="/financeiro/previsao-orcamentaria"
        component={PrevisaoOrcamentariaPages}
        permissions={[
          PermissaoEnum.Backoffice.Financeiro.Planejamento.PrevisaoOrcamentaria,
        ]}
        tenantTypes={[TipoTenantEnum.Condominio]}
      />
      <AuthRoute
        path="/financeiro/execucao-orcamentaria"
        component={ExecucaoOrcamentariaPages}
        permissions={[
          PermissaoEnum.Backoffice.Financeiro.Planejamento.ExecucaoOrcamentaria,
        ]}
        tenantTypes={[TipoTenantEnum.Condominio]}
      />
      <AuthRoute
        path="/financeiro/transferencias"
        component={TransferenciasPages}
        permissions={[
          PermissaoEnum.Backoffice.Financeiro.Transferencia.Visualizar,
        ]}
      />
      <AuthRoute path="/financeiro/dashboard" component={DashboardPages} />

      <AuthRoute
        path="/financeiro/conciliacao-bancaria"
        component={ConciliacaoBancariaPages}
        permissions={[
          PermissaoEnum.Backoffice.Financeiro.ConciliacaoBancaria.Visualizar,
        ]}
      />

      <AuthRoute
        path="/financeiro/impostos"
        component={ImpostosPages}
        permissions={[PermissaoEnum.Backoffice.Financeiro.Impostos.Visualizar]}
      />

      <AuthRoute
        path="/financeiro/consumo"
        component={ConsumoPages}
        permissions={[PermissaoEnum.Backoffice.Financeiro.Consumo.Visualizar]}
      />


<AuthRoute
        path="/financeiro/exportacao-contabil"
        component={ExportacaoContabilPages}
        permissions={[PermissaoEnum.Backoffice.Financeiro.Consumo.Visualizar]}
      />
    </Switch>
  );
}

export default FinanceiroPages;
